import { makeStyles, Theme } from "@material-ui/core/styles";

export const resetPasswordFormStyles = makeStyles((theme: Theme) => ({
  formWrapper: {
    padding: theme.spacing(3, 5),
    '& form': {
      display: "flex",
      flexDirection: "column",
    },
  },
  row: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1.5, 0), 
    "& > div": {
      flex: 1,
      margin: theme.spacing(0, 0.5),
    },
  },
  textField: {
    width: "60%",
  },
  alignRight: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: theme.spacing(2),
  },
}));